import Box from "@mui/material/Box";
import {alpha} from "@mui/material/styles";
import {CommonThemeColors} from "crqlar-react-common/dist/components/theme";
import {
    ClusterAction,
    ClusterType
} from "crqlar-react-common/dist/models/profile/profileCluster.model";
import {ElementChip} from "../../common/uiElements/base/ElementChip";

const getClusterTypeColor = (type?: ClusterType) => {
    switch (type) {
        case ClusterType.DEFINITE_MERGE:
            return CommonThemeColors.sys.success.main;
        case ClusterType.PROBABLE_MERGE:
            return CommonThemeColors.sys.warning.main;
        case ClusterType.NEEDS_REVIEW:
            return CommonThemeColors.sys.error.main;
        default:
            return CommonThemeColors.sys.palette.blueGray["600"];
    }
};

const getActionColor = (action?: ClusterAction) => {
    switch (action) {
        case ClusterAction.AUTO_MERGE:
            return CommonThemeColors.sys.success.main;
        case ClusterAction.REVIEW_BEFORE_MERGE:
            return CommonThemeColors.sys.warning.main;
        case ClusterAction.MANUAL_REVIEW:
            return CommonThemeColors.sys.error.main;
        default:
            return CommonThemeColors.sys.palette.blueGray["600"];
    }
};

const ProfileClusterStatusChip = ({text, color}: {text: string; color: string}) => (
    <ElementChip
        text={text}
        startIcon={(
            <Box
                component="span"
                sx={{width: 8, height: 8, borderRadius: "50%", bgcolor: color, flex: "0 0 auto"}}
            />
        )}
        borderColor={alpha(color, 0.34)}
    />
);

export const ProfileClusterTypeChip = ({type}: {type?: ClusterType}) => (
    <ProfileClusterStatusChip text={type || "-"} color={getClusterTypeColor(type)}/>
);

export const ProfileClusterActionChip = ({action}: {action?: ClusterAction}) => (
    <ProfileClusterStatusChip text={action || "-"} color={getActionColor(action)}/>
);
